/**************************************************************************************************************************
 Copyright (c) 2024 WorkEarly Results LLP

     Name: themed-buttons.tsx
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import { type FunctionComponent } from 'react';
/**************************************************************************************************************************
 TYPES / GLOBAL DEFINITIONS
***************************************************************************************************************************/
interface ClickableProps {
  className?: string;
  children: string;
}

interface LinkProps extends ClickableProps {
  href: string;
}

interface ButtonProps extends ClickableProps {
  onClick: () => void;
}

const commonStyle =
  'w-fit font-inter font-semibold shadow-md drop-shadow-sm rounded-[5px] px-5 py-2';

/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const Link: FunctionComponent<LinkProps> = ({ className = '', href, children }: LinkProps) => {
  return (
    <a className={`${commonStyle} ${className} transition-all duration-350`} href={href}>
      {children}
    </a>
  );
};

const Button: FunctionComponent<ButtonProps> = ({
  className = '',
  onClick,
  children
}: ButtonProps) => {
  return (
    <button className={`${commonStyle} ${className} transition-all duration-350`} onClick={onClick}>
      {children}
    </button>
  );
};

const ThemedButtons = {
  Link,
  Button
};

export default ThemedButtons;
